angular.module('mtic.components.navbar')
.directive('navBarBackArrow', function (EventManager,$q,userAccount,$log,$timeout) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarBackArrow', scope);
      var active_slug = '';
      var isClosing = false;
      scope.status = {
        show: false
      }

      var closeResource = function(){
        eventManager.broadcast('module:close:resource')
        // eventManager.clearResourceSession()
        isClosing = false;
      }

      scope.closeResource = function () {
        if(isClosing){
          return;
        }
        var invisButton = document.getElementById("backInvisInput");
        try{
          invisButton.style.display = 'inline-block';
          invisButton.focus();
          $timeout(function(){
            invisButton.blur();
            invisButton.style.display = 'none';
          },50);
        }
        catch(e){
          $log.log('hiding input field that is there')
        }

        isClosing = true;
        if (active_slug && active_slug.indexOf('_m56_') > -1 && !userAccount.getData().role.isTeacher){
          var defer = $q.defer();
          eventManager.broadcast('module:updateAndClose:resource',defer);
          defer.promise.then(closeResource,function(){
            isClosing = false;
          });
        }else{
          closeResource();
        }
        scope.status.show = false;
      }

      eventManager.listen('module:open:resource', function(e, data){
        active_slug = data.slug;
        if(data.is_forced){
          return;
        }
        scope.status.show = true;
      })

      eventManager.listen('module:close:resource', function(e, args){
        if (!(args && args.isPassive)){
          scope.status.show = false;
        }
      })

      //hide:back:arrow
      eventManager.listen('hide:back:arrow', function(e, data){
        scope.status.show = false;
      })
    }
  }
})
